module.exports = __webpack_public_path__ + "img/[苦涩].0ca3e51c.svg";